import React from 'react'
import { times } from 'lodash'

import {
  useListenCoachProgramsQuery,
  useListenProgramGroupsQuery,
  useListenTabContentQuery,
  useSetTabContentMutation,
  useListenExclusiveTabQuery,
} from 'modules/Layout/layoutApi'

import { useListenCoachVideosQuery } from 'modules/VideoLibrary/videoLibraryApi'

import LayoutRows from 'modules/Layout/components/LayoutRows/LayoutRows'
import { LoadingLayoutRow } from 'modules/Layout/components/Row/LoadingLayoutRow'

import { createUID } from 'common/utils/createUID'
import { useAlert } from 'common/components/Alert/hooks/useAlert'
import { Button } from 'common/components/Button/Button'

function Rows({ coachOrgId, tabId }) {
  const { createAlert } = useAlert()

  const { data: tab, isLoading: isLoadingTabs } = useListenExclusiveTabQuery({ coachOrgId, tabId })
  const tabLoading = tab === undefined || tab?.isLoading || isLoadingTabs
  const tabEntry = tabLoading ? null : [tabId, tab]

  const { data: tabContent, isLoading: isLoadingTabContent } = useListenTabContentQuery({
    coachOrgId,
    tabId,
  })
  const tabContentLoading = tabContent === undefined || tabContent?.isLoading || isLoadingTabContent

  const [saveTabContent, { isLoading: isUpdating }] = useSetTabContentMutation()

  const { data: programGroups } = useListenProgramGroupsQuery({ coachOrgId })
  const { data: coachPrograms } = useListenCoachProgramsQuery({ coachOrgId })
  const { data: videoData } = useListenCoachVideosQuery({ coachOrgId })
  const layoutsDataLoading = programGroups?.isLoading || coachPrograms?.isLoading || videoData?.isLoading

  const handleAddRow = async () => {
    const id = createUID()
    if (!tabContent) {
      const newTabContent = [{ id, name: 'New row', visibilityLevel: 'coaches' }]
      await saveTabContent({ coachOrgId, tabContent: newTabContent, tabId })
      return
    }

    const updatedTabContent = [...tabContent, { id, name: `New row`, visibilityLevel: 'coaches' }]
    await saveTabContent({ coachOrgId, tabContent: updatedTabContent, tabId })
    createAlert({ text: 'Row created!', type: 'success' })
  }

  const numRowLoaders = 1

  const loading = layoutsDataLoading || tabLoading || tabContentLoading || !tab

  return (
    <div className='mx-8 pt-8 pb-2 border-t border-gray-200'>
      <div className='flex justify-between mb-8'>
        <h3 className='font-bold text-xl md:text-3xl text-tBlack mr-4'>Rows</h3>
        <Button onClick={handleAddRow} size='md' disabled={loading || isUpdating}>
          Add row
        </Button>
      </div>
      {layoutsDataLoading || tabLoading || tabContentLoading || !tab ? (
        times(numRowLoaders, (idx) => <LoadingLayoutRow key={idx} />)
      ) : (
        <LayoutRows tabContent={tabContent} selectedTabEntry={tabEntry} handleAddRow={handleAddRow} />
      )}
    </div>
  )
}

export default Rows
